import axios, { CancelTokenSource } from 'axios';

export async function getEvents(source: CancelTokenSource, params?: any) {
  return axios.get(`gs/events/`, { params: params, cancelToken: source.token })
    .then(response => response.data);
};